import store from '@/store'

const state = {
  usersSortProp: 'name',
  usersSortAscending: true
}

const mutations = {
  setUsersSortProp (state, prop) {
    state.usersSortProp = prop
  },
  setUsersSortAscending (state, ascending) {
    state.usersSortAscending = ascending
  },
  toggleUsersSortAscending (state) {
    state.usersSortAscending = state.usersSortAscending !== true
  }
}

const getters = {
  usersSortProp: state => state.usersSortProp,
  usersSortAscending: state => state.usersSortAscending,
  users: () => {
    let users = store.getters['users/all']

    users.map(user => {
      let role = store.getters['roles/byId']({ id: user.relationships.role.data.id })

      user.name = user.attributes.name
      user.fullName = `${user.attributes.firstName} ${user.attributes.lastName}`
      user.role = role
      user.roleName = role ? role.attributes.name : ''
    })

    return users
  }
}

export default {
  state,
  mutations,
  getters
}
